import React from "react";
import SyncForm from "../components/sync/SyncForm";

const Sync: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Sync Programs
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Sync your affiliate programs from AWIN
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-4">
        {/* Sync Form */}
        <div className="flex-1 lg:max-w-2xl">
          <SyncForm />
        </div>

        {/* Instructions */}
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 lg:p-6 lg:max-w-sm">
          <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-3">
            How to sync
          </h3>
          <div className="space-y-3 text-sm text-blue-800 dark:text-blue-200">
            <div className="flex items-start space-x-2">
              <span className="flex-shrink-0 w-6 h-6 bg-blue-200 dark:bg-blue-800 rounded-full flex items-center justify-center text-xs font-semibold text-blue-800 dark:text-blue-200">1</span>
              <p>Get your AWIN Publisher ID and Access Token from your AWIN account</p>
            </div>
            <div className="flex items-start space-x-2">
              <span className="flex-shrink-0 w-6 h-6 bg-blue-200 dark:bg-blue-800 rounded-full flex items-center justify-center text-xs font-semibold text-blue-800 dark:text-blue-200">2</span>
              <p>Select the country and relationship status you want to sync</p>
            </div>
            <div className="flex items-start space-x-2">
              <span className="flex-shrink-0 w-6 h-6 bg-blue-200 dark:bg-blue-800 rounded-full flex items-center justify-center text-xs font-semibold text-blue-800 dark:text-blue-200">3</span>
              <p>Choose whether to include hidden programs</p>
            </div>
            <div className="flex items-start space-x-2">
              <span className="flex-shrink-0 w-6 h-6 bg-blue-200 dark:bg-blue-800 rounded-full flex items-center justify-center text-xs font-semibold text-blue-800 dark:text-blue-200">4</span>
              <p>Click "Sync Programs" to start the synchronization</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sync;
